import Component from '~/components/component';

export default class Video extends Component {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {
        this.dom.overlay = this.dom.component.querySelector(".video-overlay");
        this.dom.play = this.dom.component.querySelector(".container-video");
        this.dom.video = this.dom.component.querySelector(".video");
    }

    // bind() {
    //     // super.bind();
    //
    //     // this.dom.play.addEventListener("click", () => {
    //
    //     //     TweenLite.to(this.dom.overlay, 0.5, {
    //     //         autoAlpha: 0
    //     //     });
    //     //     this.dom.video.setAttribute("controls","");
    //     //     this.dom.video.play();
    //     // });
    //
    // }




    /*
    bind() {
    }
    unbind() {
    }

    */
}



// WEBPACK FOOTER //
// src/js/components/video/video.js